// Media element styling utilities
export const MEDIA_STYLE = {
  flexShrink: 0,
  objectFit: "cover" as const,
  transition: "opacity 0.3s ease-in-out",
};

export const getMediaStyle = (loaded: boolean, borderRadius: number) => ({
  ...MEDIA_STYLE,
  borderRadius,
  opacity: loaded ? 1 : 0,
});
